@if (isRecommendations) {
  <div class="recommendationsContainer">
    <header>
      <p>{{ 'recommendation_header' | translate }}:</p>
      <button icon-button (click)="closeRecommendation($event)">
        <gl-icon [name]="'close'"></gl-icon>
      </button>
    </header>
    @if (isCalculating) {
      <div>
        <p class="calculating">
          {{ 'calculating_recommendations' | translate }}
        </p>
      </div>
    }
    @if (activeRecommendations && !isCalculating) {
      <div [@height]>
        @for (recommendation of sortedRecommendations; track recommendation) {
          <div class="recommendations">
            <button
              [disabled]="!recommendation.hasDefaultSpacesOnly && !user.isPremium"
              [glPremium]="!recommendation.hasDefaultSpacesOnly"
              submit-button
              class="button hoverButton"
              [class.hoverButton]="recommendation.hasDefaultSpacesOnly"
              (click)="choseRecommendation(recommendation)"
              >
              {{ 'accept' | translate }}
            </button>
            <div class="loadingSpaces">
              @for (recommendedLoadingSpaces of recommendation.recommendedLoadingSpaces; track recommendedLoadingSpaces) {
                <div
                  class="loadingSpace"
                  >
                  <p class="quantity">
                    <strong>{{ recommendedLoadingSpaces.quantity + 'x' }}</strong>
                  </p>
                  <p>
                    <strong>{{ recommendedLoadingSpaces.loadingSpace.name | translate }}</strong>
                  </p>
                </div>
              }
            </div>
          </div>
        }
        @if (isError) {
          <div class="errorContainer">
            <p class="error">{{ 'recommendations_empty' | translate }}</p>
          </div>
        }
        @if (!isCalculating) {
          <div class="recalculateRecommendationContainer">
            @if (sortedRecommendations !== null && sortedRecommendations?.length < 1 && !isError) {
              <p
              class="recommendationsEmpty recommendation">{{ 'recommendations_empty' | translate }}</p>
            }
            <div class="buttons">
              <button type="button" submit-button class="button hoverButton"
                (click)="getCalculatedRecommendations()">{{ 'calculate_recommendations' | translate }}
              </button>
            </div>
          </div>
        }
      </div>
    }
  </div>
}
